import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';

import { Modal, Button, Spacer, Textarea, Checkbox } from '@ontruck/orc';
import { Loading } from 'components/Loading';

import { getJourneysSummaryModalProps } from 'redux/modules/journeys/selectors';
import { setJobsSummaryModalClosed } from 'redux/modules/journeys/duck';

import { useFiltrableJobsInfoFromShipper, useCopiableData } from './hooks';
import { formatData } from './utils';

const t = {
  a: 'a',
  copy: 'Copy to clipboard',
  title: 'Shipper order details',
  plate: 'License Plate',
  driverName: 'Driver name',
  driverPhone: 'Driver phone',
  pickup: 'Pick ups',
  copied: 'Copied! ',
};

const StyledFlexContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 5px;
`;

const JourneysSummaryModal = () => {
  const { props } = useSelector(getJourneysSummaryModalProps);
  const { shipperId, date } = props;
  const dispatch = useDispatch();

  const { fetching, filters, jobsData, changeFilter } = useFiltrableJobsInfoFromShipper(
    shipperId,
    date
  );
  const { copied, handleCopy } = useCopiableData(formatData(jobsData));

  return (
    <Modal
      show
      size="M"
      allowClose
      closeButton
      onClose={() => dispatch(setJobsSummaryModalClosed())}
      headerComponent={t.title}
      onTop
      visibleOverflow
    >
      <StyledFlexContainer>
        <Checkbox
          label={t.plate}
          size="M"
          checked={filters.PLATE}
          onChange={() => changeFilter('PLATE')}
        />

        <Checkbox
          label={t.driverName}
          size="M"
          checked={filters.NAME}
          onChange={() => changeFilter('NAME')}
        />

        <Checkbox
          label={t.driverPhone}
          size="M"
          checked={filters.PHONE}
          onChange={() => changeFilter('PHONE')}
        />

        <Checkbox
          label={t.pickup}
          size="M"
          checked={filters.PICKUP}
          onChange={() => changeFilter('PICKUP')}
        />
      </StyledFlexContainer>

      {fetching && (
        <StyledFlexContainer>
          <Loading />
        </StyledFlexContainer>
      )}
      <Spacer mBottom="M">
        <Textarea
          fullWidth
          value={formatData(jobsData)}
          labelType="hidden"
          height={'400px'}
          width={'100%'}
          disabled={fetching}
        />
      </Spacer>
      <Button fullWidth text={copied ? t.copied : t.copy} onClick={handleCopy} />
    </Modal>
  );
};

export default JourneysSummaryModal;
